angular.module('wbServices')
.factory('feeSchedule', ->
  @wealthBarMER = 0.0025
  @mutualFundMER = 0.0193
  @otherOnlineAdvisorMER = 0.004

  @schedule =
    [
      { "min" : 0, "max": 150000, "fee": 0.006 }
      { "min" : 150000, "max": 500000, "fee": 0.004 }
      { "min" : 500000, "max" : Number.MAX_VALUE, "fee" : 0.0035 }
    ]

  @otherOnlineAdvisorSchedule =
    [
      { "min" : 0, "max": 100000, "fee": 0.007 }
      { "min" : 100000, "max": 250000, "fee": 0.006 }
      { "min" : 250000, "max": 500000, "fee": 0.005 }
      { "min" : 500000, "max" : Number.MAX_VALUE, "fee" : 0.004 }
    ]

  @calculateBlendedRate = (assets) =>
    return 0 if !assets or !assets? or isNaN(assets)
    @calculateFees(assets) / assets

  @calculateOtherOnlineAdvisorFee = (assets) =>
    @calculateFees(assets, @otherOnlineAdvisorSchedule)

  @calculateFees = (assets, schedule = @schedule) =>
    return 0 if !assets or !assets? or isNaN(assets)
    assetFees = 0
    for bracket in schedule
      if assets <= bracket.max
        assetFees += (assets - bracket.min) * bracket.fee
        return assetFees

      assetFees += (bracket.max - bracket.min) * bracket.fee

    assetFees

  @calculateFeePercentage = (assets) =>
    for bracket in @schedule
      if assets <= bracket.max
        return bracket.fee

      bracket.fee
  @
)
